export const stateCard = [
  { value: "", text: "--Select your state--" },
  { value: "Andaman and Nicobar Islands", text: "Andaman and Nicobar Islands" },
  { value: "Andhra Pradesh", text: "Andhra Pradesh" },
  { value: "Arunachal Pradesh", text: "Arunachal Pradesh" },
  { value: "Assam", text: "Assam" },
  { value: "Bihar", text: "Bihar" },
  { value: "Chandigarh", text: "Chandigarh" },
  { value: "Chhattisgarh", text: "Chhattisgarh" },
  { value: "Dadra and Nagar Haveli", text: "Dadra and Nagar Haveli" },
  { value: "Daman and Diu", text: "Daman and Diu" },
  { value: "Delhi", text: "Delhi" },
  { value: "Goa", text: "Goa" },
  { value: "Gujarat", text: "Gujarat" },
  { value: "Haryana", text: "Haryana" },
  { value: "Himachal Pradesh", text: "Himachal Pradesh" },
  { value: "Jammu and Kashmir", text: "Jammu and Kashmir" },
  { value: "Jharkhand", text: "Jharkhand" },
  { value: "Karnataka", text: "Karnataka" },
  { value: "Kerala", text: "Kerala" },
  { value: "Ladakh", text: "Ladakh" },
  { value: "Lakshadweep", text: "Lakshadweep" },
  { value: "Madhya Pradesh", text: "Madhya Pradesh" },
  { value: "Maharashtra", text: "Maharashtra" },
  { value: "Manipur", text: "Manipur" },
  { value: "Meghalaya", text: "Meghalaya" },
  { value: "Mizoram", text: "Mizoram" },
  { value: "Nagaland", text: "Nagaland" },
  { value: "Odisha", text: "Odisha" },
  { value: "Puducherry", text: "Puducherry" },
  { value: "Punjab", text: "Punjab" },
  { value: "Rajasthan", text: "Rajasthan" },
  { value: "Sikkim", text: "Sikkim" },
  { value: "Tamil Nadu", text: "Tamil Nadu" },
  { value: "Telangana", text: "Telangana" },
  { value: "Tripura", text: "Tripura" },
  { value: "Uttar Pradesh", text: "Uttar Pradesh" },
  { value: "Uttarakhand", text: "Uttarakhand" },
  { value: "West Bengal", text: "West Bengal" },
];
